import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import { Modal } from "react-bootstrap";
import Delete from '../Delete/Delete.js';
import Auto_ACCC from '../AccountDetail/Auto_ACCC.js';
import Drp_DocSettingType from './Drp_DocSettingType.js';
import Drp_DocSettingUsedIn from './Drp_DocSettingUsedIn.js';




const DocSettingsIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const ACCCRef = useRef()
    const TypeRef = useRef()
    const UsedInRef = useRef()
    const TypeSearchRef = useRef()
    const UsedInSearchRef = useRef()
    const [DocSettingsList, setDocSettingsList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty());
    const [ACCCId, setACCCId] = useState(General.GuidEmpty());
    const [ACCC, setACCC] = useState('');
    const [Comment, setComment] = useState('');
    const [Type, setType] = useState(-1);
    const [UsedIn, setUsedIn] = useState(-1);
    const [IsAuto, setIsAuto] = useState(1);

    const [CommentSearch, setCommentSearch] = useState('');
    const [TypeSearch, setTypeSearch] = useState(-1);
    const [UsedInSearch, setUsedInSearch] = useState(-1);

    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    //#region Methods

    const Accc_Change = (e) => {
        setACCCId(General.GuidEmpty())
        setACCC(e)
        if (e.split("|").length > 1) {
            setACCCId(e.split("|")[0])
            setACCC(e.split("|")[1])
            return;
        }
    }

    const Search = () => {
        var RequestOptions = {
            data: {
                'Comment': CommentSearch,
                'UsedIn': UsedInSearch,
                'Type': TypeSearch,
            },
            url: General.ApiRoute() + "/DocSettings/Search",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result.data[i].id,
                            Comment: result.data[i].comment,
                            IsAuto: result.data[i].isAuto == 1 ? "صدور اسناد سیستمی - اتوماتیک" : result.data[i].isAuto == 2 ? "صدور اسناد سیستمی - اتوماتیک و دستی" : "",
                            UsedInComment: result.data[i].usedInComment,
                            TypeComment: result.data[i].typeComment,
                            ACCC: result.data[i].accc,

                        })
                    }
                    setDocSettingsList(tmp)

                })
                .catch((error) => {
                    console.dir(error)
                })
        )
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const Reset = () => {
        setComment("");
        setId(General.GuidEmpty());
        setIsAuto(1);
        setACCC("");
        setACCCId(General.GuidEmpty());
        setType(-1);
        setUsedIn(-1);
    }

    const Save = () => {

        if (Comment == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان، اجباری می باشد")), 'topCenter')
            return;
        }
        // if (Type == "-1") {
        //     toaster.push(General.ShowMessage('error', General.ErrorMessage("نوع عملیات، اجباری می باشد")), 'topCenter')
        //     return;
        // }
        if (UsedIn == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" استفاده در، اجباری می باشد")), 'topCenter')
            return;
        }
        if (ACCCId == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" حساب معین، اجباری می باشد")), 'topCenter')
            return;
        }
        alert(IsAuto)
        var RequestOptions = {
            data: {
                "Id": Id,
                "Comment": Comment,
                "ACCCId": ACCCId,
                "Type": Type,
                "UsedIn": UsedIn,
                "IsAuto": IsAuto,
            },
            url: General.ApiRoute() + "/DocSettings/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        Search();
                        if (Id == General.GuidEmpty()) {
                            setComment("");
                            setACCC("");
                            setACCCId(General.GuidEmpty());
                            setType(-1);
                        }
                        else {
                            Reset();
                            setShowModal(false);

                        }
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                    console.dir(error)
                })
        )
    }

    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(30, id, title);
    }

    const ShowEdit = (Id) => {
        Reset();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/DocSettings/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setComment(result.comment);
                    setACCCId(result.acccid);
                    setACCC(result.accc);
                    setIsAuto(result.isAuto);
                    setUsedIn(result.usedIn);
                    setType(result.type);

                    setTimeout(() => {
                        ACCCRef.current.Bind(result.acccId)
                        UsedInRef.current.Bind(result.usedIn)
                        TypeRef.current.Bind(result.type, result.usedIn)

                    }, 1000);

                })
        )
    }

    const ShowNew = () => {
        setShowModal(true);
        Reset();
        setTimeout(() => {
            ACCCRef.current.Bind("", General.GuidEmpty())
            TypeRef.current.Bind(-1, -1)
            UsedInRef.current.Bind(-1)

        }, 1000);
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 30);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        UsedInSearchRef.current.Bind(-1)
                        TypeSearchRef.current.Bind(-1, -1)

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    useEffect(() => {
        CheckPermission();
        document.title = "تنظیمات صدور سند";
    }, [])
    //#endregion



    return (

        <Layout title='تنظیمات صدور سند'>


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Search()}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label>عنوان</label>
                            <rsuite.Input value={CommentSearch} className='FocusItem' onChange={(e) => setCommentSearch(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label>استفاده در</label>
                            <Drp_DocSettingUsedIn value={UsedInSearch} onChange={(value, title) => (setUsedInSearch(value), TypeSearchRef.current.Bind(-1, value))} ref={UsedInSearchRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <label> نوع عملیات</label>
                            <Drp_DocSettingType value={TypeSearch} onChange={(value, title) => (setTypeSearch(value))} ref={TypeSearchRef} />
                        </rsuite.Col>
                    </rsuite.Row>
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={620}
                                    data={DocSettingsList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={2} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>شرح</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Comment" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>استفاده در</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="UsedInComment" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>نوع عملیات</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="TypeComment" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>صدور به صورت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="IsAuto" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>حساب معین</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="ACCC" />
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column width={60} fixed="right" >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="md" backdrop="static" keyboard={false} >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف  </b></Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Comment == "" ? 'text-danger' : 'hide'} />  <label>شرح</label>
                                <rsuite.Input value={Comment} onChange={(e) => setComment(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={UsedIn == "-1" ? 'text-danger' : 'hide'} />  <label>استفاده در</label>
                                <Drp_DocSettingUsedIn value={UsedIn} onChange={(value, title) => (setUsedIn(value), TypeRef.current.Bind(-1, value))} ref={UsedInRef} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>

                                <label> نوع عملیات</label>
                                <Drp_DocSettingType value={Type} onChange={(value, title) => (setType(value))} ref={TypeRef} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={ACCCId == General.GuidEmpty() ? 'text-danger' : 'hide'} />  <label> حساب معین </label>
                                <Auto_ACCC value={ACCC} onChange={Accc_Change} onSelect={Accc_Change} ref={ACCCRef} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.RadioGroup name="radio-group" defaultValue="1">
                                    <rsuite.Radio value="0" onChange={(e) => setIsAuto(e)} checked={IsAuto}> صدور به صورت دستی می باشد</rsuite.Radio>
                                    <rsuite.Radio value="1" onChange={(e) => setIsAuto(e)} checked={IsAuto}> صدور به صورت سیستمی (اتوماتیک) می باشد</rsuite.Radio>
                                    <rsuite.Radio value="2" onChange={(e) => setIsAuto(e)} checked={IsAuto}>صدور به صورت سیستمی (اتوماتیک) و دستی می باشد</rsuite.Radio>
                                </rsuite.RadioGroup>
                                {/* <rsuite.Checkbox onChange={(e, checked) => setIsAuto(checked)} checked={IsAuto} value={IsAuto} /> &nbsp; صدور به صورت سیستمی (اتوماتیک) می باشد */}
                            </rsuite.Col>
                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Delete ref={DeleteRef} onSubmit={Search} />
        </Layout >


    )
}


export default DocSettingsIndex;